import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
} from "@mui/material";
import React from "react";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { GridColDef, GridRowParams, MuiEvent } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useForm, SubmitHandler } from "react-hook-form";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import Link from '@mui/material/Link';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import { setPageTitle } from "../../slices/applicationSlice";
import { IApplication } from "../../interfaces/IApplication";
import { useAppDispatch } from "../../hooks";
import { ITraining } from "../../interfaces/Growing/ITraining";
import PoHeader from "./PoHeader";
import PoByOrderDetails from "./PoByOrderDetails";
import PoByItemDetails from "./PoByItemDetails";
import PoReview from "./PoReview";
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function PoOrder() {

  const dispatch = useAppDispatch();
  const [helpOpen, setHelpOpen] = React.useState(false);
  const [trainingOpen, setTrainingOpen] = React.useState(false);
  const [trainingId, setTrainingId] = useState(0);
  const [selectedTraining, setSelectedTraining] = useState<ITraining>();
  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Purchase Order",
      backgroundPath: "/assets/images/growing.jpg"
    }
    dispatch(setPageTitle(appState));
  }, []);

  const [tabValue, setTabValue] = React.useState(0);
  const [allowReview, setAllowReview] = React.useState(false);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [trainings, setTrainings] = useState<ITraining[]>([]);
  const [sprayTrainings, setSprayTrainings] = useState<ITraining[]>([]);
  const [mixTrainings, setMixTrainings] = useState<ITraining[]>([]);

  const { register, handleSubmit, control, formState: { errors }, reset, getValues, setValue } = useForm<ITraining>({
    defaultValues: {
      id: 0
    }
  });

  const onSubmit: SubmitHandler<ITraining> = data => {

  };


  const handleHelpClose = () => {
    setHelpOpen(false);
  };


  const handleTrainingClose = () => {
    setTrainingOpen(false);
    reset({})
  };


  const columnTraining: GridColDef[] = [
    { field: 'name', headerName: 'Chemical Name', width: 300 },
    { field: 'chemical', headerName: 'Title', width: 350 },
    { field: 'pdf', headerName: 'PDF', width: 200 },
    { field: 'video', headerName: 'Video Link', width: 400, },
  ];

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
  }));

  const handleDoubleClick = (x: GridRowParams<any>, y: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>) => {
    console.log("double click");
    setTrainingId(x.row.id);
    setSelectedTraining(trainings.find(t => t.id == x.row.id))
    setTrainingOpen(true);
    console.log(getValues('id'))
  }

  useEffect(() => {
    reset(selectedTraining);
  }, [selectedTraining])

  useEffect(() => {
    setSprayTrainings(trainings.filter(x => x.type == 'spray'))
    setMixTrainings(trainings.filter(x => x.type == 'mix'))

    console.log(sprayTrainings);
    console.log(mixTrainings);
  }, [trainings])

  const [isOrderDetail, setIsOrderDetail] = useState<boolean>(false);
  const [isItemDetail, setIsItemDetail] = useState<boolean>(false);

  const setDetailType = (props: string) => {
    if (props == 'item') {
      setIsItemDetail(true);
      setIsOrderDetail(false);
      return;
    } else if (props == 'order') {
      setIsItemDetail(false);
      setIsOrderDetail(true);
      return;
    }
  }

  return (
    <div>
      <Grid container spacing={0} bgcolor="#FFF" >
        <Grid item xs={12} >
          <Box sx={{ width: '100%', padding: '0' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example" >
                <Tab label="Header" {...a11yProps(0)} icon={<CheckBoxIcon />} iconPosition="start" sx={{ fontSize: '1.5em', fontWeight: '700', letterSpacing: '0' }} />
                {isItemDetail && <Tab label="Item Details" {...a11yProps(1)} icon={<CheckBoxIcon />} iconPosition="start" sx={{ fontSize: '1.5em', fontWeight: '700', letterSpacing: '0' }} />}
                {isOrderDetail && <Tab label="Order Details" {...a11yProps(1)} icon={<CheckBoxIcon />} iconPosition="start" sx={{ fontSize: '1.5em', fontWeight: '700', letterSpacing: '0' }} />}
                {allowReview && <Tab label="Review" {...a11yProps(2)} icon={<CheckBoxIcon />} iconPosition="start" sx={{ fontSize: '1.5em', fontWeight: '700', letterSpacing: '0' }} /> }
              </Tabs>
            </Box>
            <TabPanel value={tabValue} index={0}>
              <Grid item xs={12}>
                <Item sx={{ padding: "0px" }}>
                  <div style={{ height: 'calc(100vh - 158px)', width: '100%' }}>
                    <PoHeader setTabValue={setTabValue} setDetailType={setDetailType} hideButtons={false}></PoHeader>
                  </div>
                </Item>
              </Grid>
            </TabPanel>
            {isOrderDetail &&
              <TabPanel value={tabValue} index={1}>
                <Grid item xs={12}>
                  <Item sx={{ padding: "0px" }}>
                    <div style={{ height: 'calc(100vh - 158px)', width: '100%' }}>
                      <PoByOrderDetails setTabValue={setTabValue} setAllowReview={setAllowReview} hideButtons={false}></PoByOrderDetails>
                    </div>
                  </Item>
                </Grid>
              </TabPanel>}
            {isItemDetail && <TabPanel value={tabValue} index={1}>
              <Grid item xs={12}>
                <Item sx={{ padding: "0px" }}>
                  <div style={{ height: 'calc(100vh - 158px)', width: '100%' }}>
                    <PoByItemDetails setTabValue={setTabValue} setAllowReview={setAllowReview} hideButtons={false}></PoByItemDetails>
                  </div>
                </Item>
              </Grid>
            </TabPanel>}
            {allowReview && <TabPanel value={tabValue} index={2}>
              <Grid item xs={12}>
                <Item sx={{ padding: "0px" }}>
                  <div style={{ height: 'calc(100vh - 158px)', width: '100%' }}>
                    <PoReview setTabValue={setTabValue} setDetailType={setDetailType} isOrderDetail={isOrderDetail} isItemDetail={isItemDetail} setAllowReview={setAllowReview}></PoReview>
                  </div>
                </Item>
              </Grid>
            </TabPanel> }
          </Box>
        </Grid>

      </Grid>
      <div>
        <BootstrapDialog
          onClose={handleHelpClose}
          aria-labelledby="customized-dialog-title"
          open={helpOpen}
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleHelpClose}>
            Need Support?
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography sx={{ mb: 3 }} variant="body2" gutterBottom>
              If you are having issues or have questions, please contact us below.
            </Typography>
            <Button size='large' fullWidth variant="contained" startIcon={<SmartphoneIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
              <Link href="tel:8003141797" underline="none" color="#FFF"><Typography variant='h6' fontWeight={700}>800-314-1797</Typography></Link>
            </Button>
            <Button size='large' fullWidth variant="contained" startIcon={<EmailIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
              <Link href="mailto:info@idatp.com" underline="none">
                <Typography variant='h6' fontWeight={700} color="#FFF">support@idatp.com</Typography></Link>
            </Button>
          </DialogContent>
        </BootstrapDialog>
      </div>
    </div>
  );
}